import React from 'react';

import Tracker from '@openreplay/tracker';

//import * as Sentry from "@sentry/react";
import * as Sentry from '@sentry/browser';
import {
	Integrations,
} from '@sentry/tracing';

import kali from 'kali';
import axios from 'axios';
import md5 from 'md5';
import zlib from 'zlib';

import HeaderView from 'Crow/Form/Field/Custom/Vulture/Header.js';
import Sparkie from 'Crow/Form/Field/Custom/Vulture/Sparkie.js';
import { sparkieEnabled } from 'Vulture/lib/miaw/flags.js';
import AccountsView from 'Crow/Form/Field/Custom/Vulture/Accounts.js';
import BillingView from 'Crow/Form/Field/Custom/Vulture/Billing.js';
import SystemsView from 'Crow/Form/Field/Custom/Vulture/Systems.js';
import ContentView from 'Crow/Form/Field/Custom/Vulture/Content.js';
import AccountSettingsView from 'Crow/Form/Field/Custom/Vulture/AccountSettings.js';
import { ListingConfigProvider, } from 'Crow/Form/Field/Custom/Vulture/ListingConfigContext.js';
import LibraryView from 'Crow/Form/Field/Custom/Vulture/Library.js';
import SlideDeckView from 'Crow/Form/Field/Custom/Vulture/SlideDeck.js';
import VisualContentLoopsView from 'Crow/Form/Field/Custom/Vulture/VisualContentLoops.js';
import ModalView from 'Crow/Form/Field/Custom/Vulture/CustomModal.js';
import SupportView from 'Crow/Form/Field/Custom/Vulture/Support.js';
import ProofOfPlayView from 'Crow/Form/Field/Custom/Vulture/ProofOfPlay.js';
import UserAdminView from 'Crow/Form/Field/Custom/Vulture/UserAdmin';
import MigrationView from 'Crow/Form/Field/Custom/Vulture/Migration.js';
import AIGenerationDashboardView from 'Crow/Form/Field/Custom/Vulture/AIGenerationDashboard';
import RoleManagementView from 'Crow/Form/Field/Custom/Vulture/RoleManagement';
import UserProfileView from 'Crow/Form/Field/Custom/Vulture/UserProfile';

import CrowFieldCustomVultureElementsTextSmall from 'Crow/Form/Field/Custom/Vulture/Elements/TextSmall.js';
import CrowFieldCustomVultureElementsTextLarge from 'Crow/Form/Field/Custom/Vulture/Elements/TextLarge.js';
import CrowFieldCustomCommonDate from 'Crow/Form/Field/Custom/Common/Date/Date.field.js';
import CrowFieldCustomCommonDateTimezone from 'Crow/Form/Field/Custom/Common/Date/Timezone.field.js';
import CrowFieldCustomCommonDateTime from 'Crow/Form/Field/Custom/Common/Date/Time.field.js';
import CrowFieldCustomVultureElementsPhoneMessage from 'Crow/Form/Field/Custom/Vulture/Elements/PhoneMessage.js';

import SplitScreenView from 'Vulture/View/SplitScreen.js';
import LoginView from 'Vulture/View/Login.js';
import LoadingView from 'Vulture/View/Loading.js';
import SidebarView from 'Vulture/View/Sidebar.js';
import { canAccessMode } from 'Vulture/View/navItems';
import BackgroundDownloadsView from 'Vulture/View/BackgroundDownloads.js';
import PendingChangesModalView from 'Vulture/View/PendingChangesModal.js';
import ScreenshotView from 'Crow/Form/Field/Custom/Vulture/Screenshot';

import SystemProgrammingView from 'Crow/Form/Field/Custom/Vulture/SystemProgramming.js';
import ChonkyFileBrowser from 'Crow/Form/Field/Custom/Vulture/Chonky/ChonkyFileBrowser';

import {
	parseEntityName,
	mergeFD,
	makeFDFromDD,
	applyReplaceMapToKey,
} from 'Crow/Common/Crow.js';

import {
	hasSession,
	getSession,
	delSession,
	setCurrentAccountUUID,
} from 'Vulture/Session.js';

import {
	fetchAccount,
	fetchAccountList,
	// fetchAccounts,
	fetchAccountSystem,
	fetchAccountSystems,
	fetchAccountTemplates,
} from 'Vulture/Account.js';

import API from 'Vulture/lib/API.js';
import BroncoSDK from 'Vulture/lib/BroncoSDK';

import {
	addDownload,
	removeDownload,
	updateDownload,
} from 'Vulture/lib/backgroundDownloads.js';

import {
	saveData,
} from 'Vulture/Data.js';

import {
	broncoURL,
	vultureENV,
} from 'Vulture/ENV.js';

import {
	prepPendingSlideshowChanges,
} from 'Vulture/Content';

import {
	registerListingIntegration,
} from 'Vulture/Listing';

import {
	applySystemTemplateAssignment,
} from 'Vulture/SystemProgramming';

import {
	updateViewData,
} from 'Vulture/Slideshow';

import './App.css';

import CrowFieldCustomVultureElementsFloat from 'Crow/Form/Field/Custom/Vulture/Elements/Float.js';
import CrowFieldCustomVultureElementsNumber from 'Crow/Form/Field/Custom/Vulture/Elements/Number.js';
import CrowFieldCustomVultureElementsIcon from 'Crow/Form/Field/Custom/Vulture/Elements/Icon.js';
import CrowFieldCustomVultureDropDown from 'Crow/Form/Field/Custom/Vulture/Elements/DropDown.js';
import CrowFieldCustomVultureResolutionDropDown from 'Crow/Form/Field/Custom/Vulture/Elements/ResolutionDropDown.js';
import CrowFieldCustomVultureAdvancedCheckbox from 'Crow/Form/Field/Custom/Vulture/Elements/AdvancedCheckbox.js';
import CrowFieldCustomVultureThemeEditor from 'Crow/Form/Field/Custom/Vulture/ThemeEditor.js';
import CrowFieldCustomVultureElementsPhoneNumber from 'Crow/Form/Field/Custom/Vulture/Elements/PhoneNumber.js';
import CrowFieldCustomVultureElementsEmail from 'Crow/Form/Field/Custom/Vulture/Elements/Email.js';
import CrowFieldCustomVultureElementsSlack from 'Crow/Form/Field/Custom/Vulture/Elements/Slack.js';
import QrCodeComponent from 'Crow/Form/Field/Custom/Vulture/QrCode.js';

// // Google Tag Manager
import TagManager from 'react-gtm-module';
import {
	getFDValue,
} from 'Vulture/Helpers';
import ImageUploaderComponent from 'Crow/Form/Field/Custom/Vulture/Elements/Uploader.js';
import SystemAssignmentView from 'Crow/Form/Field/Custom/Vulture/SystemAssignment';
import EntertainmentEditor from 'Crow/Form/Field/Custom/Vulture/EntertainmentEditor';
import DataPresetsView from 'Crow/Form/Field/Custom/Vulture/DataPresetsView';
import MFAView from 'Vulture/View/MFA';
import {
	s3,
} from 'S3';
import {
	fetchBuildings,
} from 'Vulture/Buildings';

import {
	initPermissions,
	hasPermission,
} from 'Vulture/Permissions';

// Dashboard modes that only exist when the account has the VCL feature enabled.
const VCL_MODES = [ 'slide_deck', 'visual_content_loop', ];

import {
	initSalesforceChat,
	clearSalesforceChat,
} from 'Vulture/lib/SalesforceChat';

import {
	DndProvider,
} from 'react-dnd';
import {
	HTML5Backend,
} from 'react-dnd-html5-backend';
import {
	VisualContentLoopProvider,
} from 'Crow/Form/Field/Custom/Vulture/VisualContentLoopContext';

const broncoSDK = new BroncoSDK({
	baseURL: broncoURL,
});

// OpenReplay: don't add code above this!
const tracker = new Tracker({
	projectKey: '7319513123710080',
});

tracker.start({
	metadata: {
		env: vultureENV,
	},
});

// Google Tag Manager
let tagManagerArgs = {
	gtmId: 'GTM-P6VSDCR',
};
TagManager.initialize(tagManagerArgs);

if (vultureENV !== 'dev') {
	// Sentry
	Sentry.init({
		dsn: 'https://b16470ab676746309ef9e65a1db0a304@o577885.ingest.sentry.io/5733659',
		integrations: [
			new Integrations.BrowserTracing(),
		],
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
	});
}

console.log('COMMITHASH=' + window._env_.COMMITHASH);

const fetchComponent = async function (componentUUID) {
	const session = getSession();

	let url = `${broncoURL}/content/component`;
	let headers = {
		'X-Auth-Session': session.session,
	};
	let body = {
		component: componentUUID,
	};

	try {
		let res = await axios.post(url, body, {
			headers,
		});
		if (res.status !== 200) {
			debugger;
		}

		return res.data;
	} catch (err) {
		console.error(err);
		debugger;
		this.setState({
			confirmModal: true,
			confirmModalContent: <>
				<p>A network error has occured.</p>
				<div className="confirm-modal-buttons">
					<button className="button-outlined" onClick={(e) => {
						this.setState({
							confirmModal: false,
						});
						this.fetchComponent(componentUUID);
					}}>Retry</button>
					<button className="button" onClick={(e) => {
						this.setState({
							confirmModal: false,
						});
					}}>Return</button>
				</div>
			</>,
		});
	}
};

// TODO: fully remove this from SystemProgramming
const initializeWindowForm = () => {
	window.form = {
		orgVals: {},
		newVals: {},
		rawKeys: [],

		props: {
			showLoader: (b) => {
				console.warn('REMOVE:');
				console.trace(' - form.props.showLoader:', b);
			},
		},

		hasNewVals: () => {
			return Boolean(Object.keys(window.form.newVals).length > 0);
		},

		_rawData: () => {
			let vals = Object.assign({}, window.form.orgVals);
			for (let [m1Key, m1Data,] of Object.entries(window.form.newVals)) {
				if (!vals[m1Key]) {
					vals[m1Key] = m1Data;
					continue;
				}

				vals[m1Key] = Object.assign({}, vals[m1Key], m1Data);
			}

			return vals;
		},

		_makeRawKeys(rawData = {}) {
			let rawKeys = [];
			for (let [m1Key, m1Data,] of Object.entries(rawData)) {
				rawKeys.push(m1Key);
				for (let [m2Key, m2Data,] of Object.entries(m1Data)) {
					if (!~m2Key.indexOf('.')) {
						// col
						rawKeys.push(`${m1Key}.${m2Key}`);
					} else {
						// rel
						rawKeys.push(`${m1Key}.${m2Key}`);
						for (let attr of Object.keys(m2Data)) {
							// attr
							rawKeys.push(`${m1Key}.${m2Key}.${attr}`);
						}
					}
				}
			}

			return rawKeys;
		},

		makeRawKeys: () => {
			if (window.form.rawKeys.length === 0) {
				window.form.rawKeys = window.form._makeRawKeys(window.form._rawData());
			}

			return window.form.rawKeys;
		},

		_getMatchingKeys(rawKeys = [], scopes = []) {
			let matchingKeys = [];
			scopes.forEach((scope) => {
				if (!scope.startsWith('*')) {
					// scope = `^${scope}$`;
				}

				let scopeStr = scope
					// *.*.* > *\\.*\\.*
					.replace(/\./g, '\\.')
					// *\\.*\\.* > .*\\..*\\..*
					.replace(/\*/g, '[A-Za-z0-9-_]+');

				let scopeRE = new RegExp(`^${scopeStr}$`);
				// console.log(scope, scopeRE);

				rawKeys.forEach((key) => {
					if (scopeRE.test(key)) {
						matchingKeys.push(key);
					}
				});
			});

			return matchingKeys;
		},

		getMatchingKeys: (scopes = []) => {
			if (!Array.isArray(scopes)) {
				scopes = [scopes,];
			}

			// TODO: don't make rawKeys each time
			return window.form._getMatchingKeys(window.form.makeRawKeys(), scopes);
		},

		_getMatchingVals(matchingKeys = []) {
			let rawData = window.form._rawData();

			let matchingVals = {};
			matchingKeys.forEach((entityKey) => {
				let s = entityKey.split('.');
				let l = s.length;

				let [m1, m1ID, col,] = s;
				let m1Key = `${m1}.${m1ID}`;

				if (l === 'm1.id.col'.split('.').length) {
					matchingVals[`${m1Key}.${col}`] = rawData[m1Key][col];
				}

				if (l >= 'm1.id.m2.id'.split('.').length) {
					let [, , m2, m2ID, attr,] = s;
					let m2Key = `${m2}.${m2ID}`;

					matchingVals[`${m1Key}.${m2Key}`] = true;
					if (attr) {
						if (!rawData[m1Key] || !rawData[m1Key][m2Key] || typeof rawData[m1Key][m2Key][attr] === 'undefined') {
							// debugger;
						}

						matchingVals[`${m1Key}.${m2Key}.${attr}`] = rawData[m1Key][m2Key][attr];
					}
				}
			});

			return matchingVals;
		},

		getValues: (scopes = []) => {
			let values = {};
			for (let [k, v,] of Object.entries(window.form.getMatchingVals(scopes))) {
				values[k] = {
					value: v,
				};
			}

			return values;
		},

		getMatchingVals: (scopes = []) => {
			if (!Array.isArray(scopes)) {
				scopes = [scopes,];
			}

			return window.form._getMatchingVals(window.form.getMatchingKeys(scopes));
		},

		getValue: (entityName) => {
			if (~entityName.indexOf('*')) {
				return window.form.getValues([entityName,]);
			}

			let vals = Object.assign({}, window.form.orgVals, window.form.newVals);
			if (entityName.endsWith('._bundle')) {
				// debugger;
			}

			let l = entityName.split('.').length;
			let [m1, m1UUID, m2, m2UUID, attr,] = entityName.split('.');
			let m1Key = `${m1}.${m1UUID}`;
			let m2Key = `${m2}.${m2UUID}`;

			if (!vals[m1Key]) {
				return null;
			}

			try {
				if (l === 3) {
					let col = m2;
					return vals[m1Key][col];
				}
				if (l === 4) {
					if (!vals[m1Key][m2Key]) {
						return;
					}
					return vals[m1Key][m2Key];
				}
				if (l === 5) {
					if (!vals[m1Key][m2Key]) {
						return;
					}
					return vals[m1Key][m2Key][attr];
				}
			} catch (err) {
				console.error(err);
				// debugger;
			}
		},

		setValue: (entityNames = [], values = []) => {
			if (typeof entityNames === 'string') {
				entityNames = [entityNames,];
				values = [values,];
			}

			if (entityNames.length !== values.length) {
				return;
			}

			for (let i = 0; i < entityNames.length; i++) {
				let entityName = entityNames[i];
				let value = values[i];

				let l = entityName.split('.').length;
				let [m1, m1UUID, m2, m2UUID, attr,] = entityName.split('.');
				let m1Key = `${m1}.${m1UUID}`;
				let m2Key = `${m2}.${m2UUID}`;

				if (!window.form.newVals[m1Key]) {
					window.form.newVals[m1Key] = {};
				}
				if (l > 3 && !window.form.newVals[m1Key][m2Key]) {
					window.form.newVals[m1Key][m2Key] = {};
				}

				if (l === 3) {
					let col = m2;
					window.form.newVals[m1Key][col] = value;
				}
				if (l === 4 && value !== true) {
					window.form.newVals[m1Key][m2Key] = value;
				}
				if (l === 5) {
					window.form.newVals[m1Key][m2Key][attr] = value;
				}
			}
			window.form.rawKeys = window.form._makeRawKeys(window.form._rawData());
		},

		parseEntityName: (entityName) => {
			return parseEntityName(entityName);
		},

		req: (action, method, uri, opts = {}, cb = () => { }, ...params) => {
			console.log('ACTION:', action);
			console.log('URI:', uri, method);

			// TODO: move Admin Forms V2 to Cookie.set('sesion_key')
			let sessionKey = getSession().session;
			if (!opts.headers) {
				opts.headers = {};
			}
			opts.headers['X-Auth-Session'] = sessionKey;

			new kali(opts)[method](uri, {
				success: (_kali, res, crowRes) => {
					if (action === 'POST_FORM_DATA') {
						console.log(crowRes);

						let values = window.form._rawData();
						Object.values(crowRes.data).forEach((m1DataGroup) => {
							Object.entries(m1DataGroup).forEach(([m1Key, m1Data,]) => {
								values[m1Key] = Object.assign({}, values[m1Key], m1Data);
							});
						});

						Object.entries(values).forEach(([m1Key, m1Data,]) => {
							Object.entries(m1Data).forEach(([m2Key, m2Data,]) => {
								if (m1Key.split('.')[0] === 'account') {
									if (m2Key.split('.')[0] === 'template' && m2Data === false) {
										delete values[m1Key][m2Key];
										delete values[m2Key];
									}
								}

								if (m1Key.split('.')[0] === 'system') {
									if (m2Key.split('.')[0] === 'component' && m2Data === false) {
										delete values[m1Key][m2Key];
									}
									if (m2Key.split('.')[0] === 'template' && m2Data === false) {
										delete values[m1Key][m2Key];
									}
								}
							});
						});

						// TODO: Update matchingKeys cache.

						window.form.orgVals = values;
						window.form.newVals = {};
						window.form.rawKeys = window.form._makeRawKeys(window.form._rawData());

						if (typeof cb === 'function') {
							return cb(...params);
						}
					}
				},

				failure: (_kali, res, err) => {
					console.log(_kali);
					console.log(err);

					if (res.status === 503) {
						// TODO: handle 503 maintenance mode
					}
				},
			}, true);
		},

		postFormData: (e, cb = false, ...params) => {
			if (Object.keys(window.form.newVals || {}).length === 0) {
				return;
			}

			// TODO: move to bronco when _cache is gone
			for (let m1Key of Object.keys(window.form.newVals)) {
				if (m1Key.startsWith('template_skeleton.')) {
					let data = zlib.gzipSync(JSON.stringify(window.form.newVals[m1Key].data)).toString('base64');
					let hash = md5(data);

					window.form.newVals[m1Key].data = data;
					window.form.newVals[m1Key].hash = hash;
				}
			}

			// m1.id.col: val
			// m1.id.m2.id: true/false
			// m1.id.m2.id.attr: val
			let dd = {};
			Object.entries(window.form.newVals).forEach(([m1Key, m1Data,]) => {
				// cols
				Object.entries(m1Data).forEach(([col, val,]) => {
					if (!~col.indexOf('.')) {
						let k = `${m1Key}.${col}`;
						dd[k] = val;
					}
				});
				// rels/attr
				Object.entries(m1Data).forEach(([m2Key, m2Data,]) => {
					if (~m2Key.indexOf('.')) {
						let k = `${m1Key}.${m2Key}`;
						dd[k] = Boolean(window.form.newVals[m1Key][m2Key]);
						Object.entries(m2Data).forEach(([attr, val,]) => {
							let k = `${m1Key}.${m2Key}.${attr}`;
							dd[k] = val;
						});
					}
				});
			});

			let body = {
				data_format: 'DD',
				data: dd,
			};
			console.log(body);

			let uri = `${broncoURL}/w/edit`;
			window.form.req('POST_FORM_DATA', 'post', uri, {
				body,
			}, cb, ...params);
		},
	};
};

initializeWindowForm();

const defaultState = {
	// /account/*
	accountList: false,
	accountName: '',
	accountSystems: {},
	accountSystem: {},
	accountTemplates: {},
	accountUUID: '',
	systemGroupUUID: '',

	// TODO: avoid this?
	accountFD: {},
	slideshow: {},
	settingMap: {},

	// /content/*
	componentUUID: null,
	componentMap: {},
	componentTypeMap: {},
	componentSettingMap: {},
	settingUUIDMap: {},
	entertainment: false,

	//modal
	confirmModal: false,
	confirmModalContent: {},
	// app.*
	loading: false,
	pendingRequests: 0,
	backgroundDownloads: {},
	// used to override app.load control of loading
	forceLoading: false,
	modal: false,
	modalProps: {},
	libraryModal: false,
	libraryModalProps: {},
	// Sparkie docked chat panel (DEV-11924)
	sparkieOpen: false,
	photos: [],
	stockPhotos: [],

	// ?
	pendingChanges: {},
	pendingSlideshowChanges: {},

	accountFDWithPendingChanges: {},

	// ?
	componentTypes: [],
	systemData: {},
	systemUUID: '',
	bucketName: 'ts-condor-assets',

	// for displaying system expirations
	nearestSystemExpiration: undefined,
	expirationDate: undefined,

	buildingsDataArray: [],

	// permissions
	permissionsInitialized: false,
	sideBarClickTime:       Date.now(),
	pendingPromises:        {},
	// Named groups of queued promises with an onSettled handler that runs
	// once the whole group resolves. See queuePendingPromiseGroup; the
	// listing_config save flow uses this to do its trailing refetch once
	// regardless of how many per-action calls landed.
	// Shape: { [groupName]: { thunks: { [key]: () => Promise }, onSettled: (results) => Promise<void> } }
	pendingPromiseGroups:   {},
};

// TODO: function DashboardMaintenanceView(props) {}
// Exported for unit tests; the app itself renders it through VultureFormLogin below.
export class DashboardView extends React.Component {
	constructor(props) {
		super(props);

		document.title = 'TouchSource Cloud Customer Dashboard';

		this.state = {
			...JSON.parse(JSON.stringify(defaultState)),
		};

		this.setSystemGroupUUID = this.setSystemGroupUUID.bind(this);

		// ListingConfigProvider owns the listingConfigMap state. App.js writes
		// to it imperatively through this ref. Consumers read directly from
		// context (useListingConfig / static contextType).
		this.listingConfigRef = React.createRef();
	}

	clearState() {
		this.listingConfigRef.current?.clearListingConfigMap();
		this.setState(JSON.parse(JSON.stringify(defaultState)));
	}

	// Legacy user-management routes retired in favor of the unified Users page
	// (userAdmin). /accountUsers keeps its account context as a list filter;
	// /users was the global admin page so it lands unfiltered.
	// reload matters on the mount path: a cold deep link early-returns before the
	// permissions/accounts fetches, and the soft redirect doesn't remount — a full
	// reload at the target re-runs the whole init there. In-SPA navigation
	// (componentDidUpdate) already ran init, so it redirects softly.
	redirectLegacyUserModes({ reload = false, } = {}) {
		const {
			params,
		} = this.props.router;

		if (params.mode === 'accountUsers') {
			this.redirect({
				to: params.account ? `/userAdmin/${params.account}` : '/userAdmin',
				reload,
			});

			return true;
		}

		if (params.mode === 'users') {
			this.redirect({
				to: '/userAdmin',
				reload,
			});

			return true;
		}

		return false;
	}

	componentDidMount() {
		const {
			router,
		} = this.props;

		const {
			params,
		} = router;

		if (params.mode === 'calendar' || params.mode === 'connect') {
			let provider = window.location.pathname.split('/').pop();

			let url = new window.URL(window.location.href);
			let code = url.searchParams.get('code');

			sessionStorage.content_auth_component = params.account;
			sessionStorage.content_auth_provider = provider;
			sessionStorage.content_auth_code = code;

			this.redirect({
				// to:     `/content/${sessionStorage.content_account_uuid}?provider=${provider}&code=${code}`,
				to: `/content/${sessionStorage.content_account_uuid}`,
				reload: true,
				search: false,
			});

			return;
		}

		if (!hasSession()) {
			let pn = window.location.pathname;

			if (pn !== '/' && pn !== '/login' && !pn.startsWith('/password/reset') && !pn.startsWith('/register')) {
				this.redirect({
					to: '/',
					redirect: false,
				});

				return;
			}

			return;
		}

		if (hasSession()) {
			if (this.redirectLegacyUserModes({ reload: true, })) {
				return;
			}

			// Set the account lock synchronously from the URL BEFORE the concurrent
			// fetches, so a deep-link/refresh of /systems/{account} sends X-Account-UUID
			// on the permissions/accounts requests (avoids a transient account-blind
			// fetch). setAccountUUID later re-confirms it once accounts load.
			setCurrentAccountUUID(params.account || '');

			Promise.all([
				this.apiFetchUserAccounts(),
				this.apiFetchPermissions(),
			]).then(() => {
				initSalesforceChat();
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			router,
		} = this.props;

		const {
			params,
		} = router;


		if (prevProps.router.params.mode !== params.mode) {
			console.log('MODE:', params.mode || 'NO_MODE');

			if (this.redirectLegacyUserModes()) {
				return;
			}

			if (prevProps.router.params.mode === 'system_programming') {
				window.location.reload();
				return;
			}

			if (!params.mode || params.mode === 'undefined') {
				if (params.account) {
					this.redirect({
						to:     `/systems/${params.account}`,
						reload: false,
					});

					return;
				}
			}

			if (params.mode === 'accounts' && !params.account) {
				// "All Accounts" / the account-search landing is account-blind: clear the
				// per-account lock so requests aren't scoped to the account we just left,
				// and re-resolve permissions account-blind. Without this the landing stayed
				// locked to the previous account.
				setCurrentAccountUUID('');
				this.setState({
					accountUUID: '',
					accountName: '',
				});
				this.apiFetchPermissions();
			}

			// logout
			if (!params.mode && !params.account) {
				this.clearState();
			}
		}

		if (prevProps.router.params.account !== params.account) {
			console.log('ACCOUNT:', params.account || 'NO_ACCOUNT');

			if (params.mode === 'system_programming' || params.mode === 'account_settings') {
				this.setState({
					accountFD: {},
				});

				return;
			}
		}

		if (prevState.accountFD !== this.state.accountFD) {
			this.setState({
				accountFDWithPendingChanges: mergeFD(this.state.accountFD, makeFDFromDD(this.state.pendingChanges)),
			});
		}
	}

	logout() {
		console.log('Attempting to log out');
		setCurrentAccountUUID('');
		clearSalesforceChat();
		delSession();
		this.setState(JSON.parse(JSON.stringify(defaultState)));

		initializeWindowForm();

		this.redirect({
			to: '/',
		});
	}

	toggleSparkie() {
		// Functional form: derive from the previous state so rapid toggles can't
		// lose an update under React's batched setState.
		this.setState((prev) => ({
			sparkieOpen: !prev.sparkieOpen,
		}));
	}

	closeSparkie() {
		this.setState({
			sparkieOpen: false,
		});
	}

	redirect(args) {
		const {
			router,
		} = this.props;

		let search = true;
		if (args.search === false) {
			search = false;
		}

		if (search) {
			args.to += window.location.search;
		}

		this.setState({
			sideBarClickTime: Date.now(),
		});

		router.redirect(args);
	}

	params() {
		const {
			router,
		} = this.props;

		return router.params;
	}

	load(cb = async () => { }) {
		this.setState((prevState) => {
			return {
				loading: true,
				pendingRequests: prevState.pendingRequests + 1,
			};
		}, async () => {
			try {
				await cb();
			} catch (err) {
				console.error(err);
				this.setState({
					confirmModal: true,
					confirmModalContent: <>
						<p>A network error has occured.</p>
						<div className="confirm-modal-buttons">
							<button className="button" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
							}}>Return</button>
						</div>
					</>,
				});
				return this.setState((prevState) => {
					return {
						lastErr: err.message,
						loading: false,
						pendingRequests: prevState.pendingRequests - 1,
					};
				});
			}

			return this.setState((prevState) => {
				return {
					loading: false,
					pendingRequests: prevState.pendingRequests - 1,
				};
			});
		});
	}

	saveDataAndCloseModal(name, cb = () => { }) {
		this.saveData(name, () => {
			this.closeModal(cb);
		});

		this.saveSlideshowData(() => {
			this.setState({
				modal:      false,
				modalProps: {},
			}, () => {
				cb();
			});
		});

		// Only one of the two queues should run the user's cb — both call
		// it on completion and cb usually wraps closeModal / caller's
		// onSuccess, which should fire once. The groups queue runs after
		// the flat queue (in the typical save flow nothing critical lives
		// in the flat queue), so anchor cb there.
		this.runPendingPromises();
		this.runPendingPromiseGroups(cb);
	}

	saveData(name, cb = () => { }, _blurAttempted = false) {
		// DEV-11750: if the user is still focused on an input when they
		// click SAVE, the input's onBlur hasn't fired yet — its setValue
		// for the just-typed value is still pending. Reading state below
		// would miss that update and we'd POST stale data (commonly a new
		// listing_column.<uuid>.display_name="" while the input visibly
		// shows the typed text). Force blur and defer one tick so React
		// flushes the queued setState before we read pendingChanges.
		//
		// `_blurAttempted` guards against infinite recursion: if a blur
		// handler synchronously refocuses an INPUT/TEXTAREA, the deferred
		// re-entry would see an INPUT as activeElement again and loop. We
		// attempt the blur at most once per saveData call chain.
		if (!_blurAttempted) {
			const ae = typeof document !== 'undefined' && document.activeElement;
			if (ae && typeof ae.blur === 'function' && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA')) {
				ae.blur();
				setTimeout(() => this.saveData(name, cb, true), 0);
				return;
			}
		}

		const {
			accountFD,
			pendingChanges,
			componentUUID,
			entertainment,
		} = this.state;

		if (Object.keys(pendingChanges).length === 0) {
			// No entity-level changes to POST, but the caller's cb may still
			// fire async follow-up work (e.g. `await app.runPendingPromiseGroups()`
			// from AccountSettings). Wrap in this.load so state.loading stays
			// true until cb resolves — otherwise the global loader clears
			// immediately and any waiter (playwright assertLoadBar, the user
			// staring at Save) sees "done" while background thunks are still
			// flushing.
			if (typeof cb === 'function') {
				this.load(async () => {
					await cb();
				});
			}
			return;
		}

		let body = {
			data_format: 'DD',
			data: pendingChanges,
		};
		this.load(async () => {
			let saveRes = await saveData(body);
			console.log('SAVE_RES:', saveRes);
			if (saveRes === undefined || saveRes.error) {
				// Retry only makes sense for transient/network failures — a 4xx
				// (permission/validation) will just fail again.
				const isClientError = saveRes?.status >= 400 && saveRes?.status < 500;
				this.setNetworkErrorModal(!isClientError, saveRes?.error);
				return;
			}
			let states = ['accountFD',];

			let updates = {
				accountFD,
				pendingChanges: {},
			};
			for (let [m1Key, saveResFD,] of Object.entries(saveRes.data)) {
				states.forEach((k) => {
					updates[k] = mergeFD(updates[k], saveResFD);
				});
			}

			// DEV-11750: rewrite tentative `_<uuid>` IDs the client minted
			// into the real UUIDs the server assigned, so preserved rels
			// don't end up as ghosts in accountFD. See applyReplaceMapToKey
			// in Crow/Common/Crow.js.
			const replaceMap = (saveRes && saveRes.keys) || {};
			const rewriteKey = (key) => applyReplaceMapToKey(key, replaceMap);

			for (let [entityKey, value,] of Object.entries(pendingChanges)) {
				if (value === null) {
					const k2 = rewriteKey(entityKey);
					states.forEach((k) => {
						updates[k] = mergeFD(updates[k], makeFDFromDD({
							[k2]: value,
						}));
					});
				}
			}

			// Preserve new relationship entries (e.g. account→system_group)
			// in case the save response didn't include the parent entity.
			for (let [entityKey, value,] of Object.entries(pendingChanges)) {
				const rewrittenKey = rewriteKey(entityKey);
				let s = rewrittenKey.split('.');

				if (s.length === 4 && value === true) {
					states.forEach((k) => {
						updates[k] = mergeFD(updates[k], makeFDFromDD({
							[rewrittenKey]: value,
						}));
					});
				}
			}

			for (let [entityKey, value,] of Object.entries(pendingChanges)) {
				const rewrittenKey = rewriteKey(entityKey);
				let s = rewrittenKey.split('.');

				if (s.length === 4 && value === false) {
					let [m1, m1UUID, m2, m2UUID,] = s;

					let m1Key = `${m1}.${m1UUID}`;
					let m2Key = `${m2}.${m2UUID}`;

					states.forEach((k) => {
						if (updates[k][m1Key]) {
							if (updates[k][m1Key][m2Key]) {
								Reflect.deleteProperty(updates[k][m1Key], m2Key);
							}
						}
					});
				}
			}

			// Promisify so this.load's outer `await cb()` waits for the
			// caller's cb chain to fully resolve — including any async
			// follow-up like `await app.runPendingPromiseGroups()`. Without
			// this, this.load clears state.loading before the queued group
			// thunks flush and any assertLoadBar-style waiter (playwright
			// tests, or a human clicking Save) sees the spinner disappear
			// while background work is still in flight.
			await new Promise((resolve, reject) => {
				this.setState(updates, async () => {
					try {
						if (componentUUID && !entertainment) {
							this.fetchComponent(componentUUID);
						}

						const needsBuildingFetch = Object.keys(pendingChanges).some(
							(key) => {
								return key.startsWith('building.');
							}
						);

						if (needsBuildingFetch && name !== 'buildings') {
							this.fetchAccountBuildings();
						}

						resolve((() => {
							if (typeof cb === 'function') {
								return cb(saveRes);
							}
						})());
					} catch (err) {
						reject(err);
					}
				});
			});
		});
	}

	saveSlideshowData(cb = () => { }) {
		const {
			componentUUID,
			pendingSlideshowChanges,
		} = this.state;

		if (Object.keys(pendingSlideshowChanges).length === 0) {
			return;
		}

		const broncoPendingChanges = prepPendingSlideshowChanges(pendingSlideshowChanges);

		if (broncoPendingChanges) {
			this.setValue('slideshow', broncoPendingChanges.keys, broncoPendingChanges.vals, () => {
				this.saveData('slideshow', () => {
					this.setState({
						pendingSlideshowChanges: {},
					}, () => {
						if (componentUUID) {
							this.fetchComponent(componentUUID);
						}

						if (typeof cb === 'function') {
							return cb();
						}
					});
				});
			});
		} else {
			this.setState({
				pendingSlideshowChanges: {},
			}, () => {
				if (componentUUID) {
					this.fetchComponent(componentUUID);
				}

				if (typeof cb === 'function') {
					return cb();
				}
			});
		}
	}

	saveSlideshowOrder() {
		const {
			accountUUID,
			// systemGroupUUID,
			pendingSlideshowChanges,
		} = this.state;

		if (Object.keys(pendingSlideshowChanges).length === 0) {
			return;
		}

		if ((pendingSlideshowChanges.order || []).length === 0) {
			return;
		}

		const body = {
			accountUUID,
			// systemGroupUUID,
			order: (pendingSlideshowChanges.order || []).map((slide) => {
				return slide.id;
			}),
		};

		fetch(`${broncoURL}/pelican/updateOrder`, {
			method:  'POST',
			headers: {
				'Content-Type':   'application/json',
				'X-Auth-Session': getSession().session,
			},
			body: JSON.stringify(body),
		}).then(async (res) => {
			if (res.status === 200) {
				Reflect.deleteProperty(pendingSlideshowChanges, 'order');

				this.setState({
					pendingSlideshowChanges: {
						...pendingSlideshowChanges,
					},
				});
			}
		}).catch((err) => {
			console.error(err);
		});
	}

	async queuePendingPromises(promiseSetID, promiseArray) {
		this.setState((state) => {
			return {
				pendingPromises: { // used for navigation prevention
					...state.pendingPromises,
					[promiseSetID]: [ ...promiseArray, ],
				},
			};
		});
	}

	// Drops queued promise sets without running them — counterpart to
	// queuePendingPromises for actions invalidated before Save (e.g. a
	// listing_config created then deleted in the same batch).
	cancelPendingPromises(promiseSetIDs) {
		if (!promiseSetIDs || promiseSetIDs.length === 0) {
			return;
		}
		this.setState((state) => {
			const next = { ...state.pendingPromises, };
			for (const id of promiseSetIDs) {
				delete next[id];
			}
			return { pendingPromises: next, };
		});
	}

	// Adds (or replaces) a thunk in the named group and registers/updates
	// the group's onSettled handler. On Save runPendingPromiseGroups runs
	// the group's thunks in insertion order (sequential await) and calls
	// onSettled once with the full results array regardless of how many
	// succeeded or failed. Insertion order = dependency order in practice
	// (you can only target a UUID after the action that minted it queued),
	// so sequential execution lets a "create X" thunk land before any
	// later "update/delete X" thunk targets the same UUID.
	//
	// Useful for batches where every per-action call shares a single
	// post-save side effect (the listing_config flow uses it to trigger
	// fetchListingConfigs exactly once at the end of a save).
	queuePendingPromiseGroup(groupName, promiseKey, thunk, onSettled) {
		this.setState((state) => {
			const groups = { ...(state.pendingPromiseGroups || {}), };
			const existing = groups[groupName] || { thunks: {}, onSettled: null, };
			groups[groupName] = {
				thunks:    { ...existing.thunks, [promiseKey]: thunk, },
				onSettled: onSettled || existing.onSettled,
			};
			return { pendingPromiseGroups: groups, };
		});
	}

	cancelPendingPromiseGroupKeys(groupName, promiseKeys) {
		if (!promiseKeys || promiseKeys.length === 0) {
			return;
		}
		this.setState((state) => {
			const groups = { ...(state.pendingPromiseGroups || {}), };
			const group = groups[groupName];
			if (!group) {
				return null;
			}
			const nextThunks = { ...group.thunks, };
			for (const key of promiseKeys) {
				delete nextThunks[key];
			}
			groups[groupName] = { ...group, thunks: nextThunks, };
			return { pendingPromiseGroups: groups, };
		});
	}

	// Predicate variant of cancelPendingPromiseGroupKeys. Used when the set
	// of keys to drop can't be enumerated up front — e.g. a pending column
	// with dynamic-suffix update keys (updateListingColumn_<uuid>_entity_*)
	// whose exact suffixes depend on which fields the user touched.
	cancelPendingPromiseGroupKeysMatching(groupName, predicate) {
		this.setState((state) => {
			const groups = { ...(state.pendingPromiseGroups || {}), };
			const group = groups[groupName];
			if (!group) {
				return null;
			}
			const nextThunks = {};
			for (const [ key, value, ] of Object.entries(group.thunks || {})) {
				if (!predicate(key)) {
					nextThunks[key] = value;
				}
			}
			groups[groupName] = { ...group, thunks: nextThunks, };
			return { pendingPromiseGroups: groups, };
		});
	}

	async runPendingPromises(cb = () => { }) {
		const {
			pendingPromises,
		} = this.state;

		const pendingPromisesArray = Object.values(pendingPromises).reduce((total, sub) => {
			total.push(...sub);
			return total;
		}, []);

		for (const promise of pendingPromisesArray) {
			await promise();
		}

		this.setState({
			pendingPromises: {},
		});

		return cb();
	}

	async runPendingPromiseGroups(cb = () => { }) {
		const {
			pendingPromiseGroups,
		} = this.state;

		for (const [ groupName, group, ] of Object.entries(pendingPromiseGroups || {})) {
			const thunks = Object.values(group.thunks || {});
			const results = [];
			for (const t of thunks) {
				try {
					const value = await t();
					results.push({ status: 'fulfilled', value, });
				} catch (err) {
					console.error(`pendingPromiseGroup ${groupName} thunk failed:`, err);
					results.push({ status: 'rejected', reason: err, });
				}
			}
			if (typeof group.onSettled === 'function') {
				try {
					await group.onSettled(results);
				} catch (err) {
					console.error(`pendingPromiseGroup ${groupName} onSettled failed:`, err);
				}
			}
		}

		this.setState({
			pendingPromiseGroups: {},
		});

		return cb();
	}

	handleOutdatedCommithashValidation(res) {
		if (res === 'outdated commithash') {
			if (window.location.search.includes('outdated_commithash=true')) {
				this.setCommitHashErrorModal();
				// this.logout();
				// window.location.replace('/');
			} else {
				window.location.search = '?outdated_commithash=true';
			}
			return true;
		}
		return false;
	}

	async apiFetchPermissions(cb = () => { }) {
		this.setState({
			loading: true,
		});

		try {
			const session = getSession();
			broncoSDK.setAuth(session.session, session.user);
			let permissionsRes = await broncoSDK.getUserPermissions();
			
			// Initialize the permissions utility with the API response
			initPermissions(permissionsRes);

			this.setState({
				permissions: permissionsRes,
				permissionsInitialized: true,
			});
		} catch (err) {
			console.error('[Permissions] Error fetching permissions:', err);
		} finally {
			this.setState({
				loading: false,
			}, () => {
				if (typeof cb === 'function') {
					return cb();
				}
			});
		}
	}

	async apiFetchUserAccounts(cb = () => { }) {
		this.setState({
			loading: true,
		});

		try {
			// Lightweight: one call returning the user's accessible accounts
			// (uuid + name) straight from user_to_account_map. Avoids the v1
			// findMapRecords('user',...)/findRecord('account',...) calls, which are
			// permission-gated (read on user/account) and 403 for scoped users.
			let res = await fetchAccountList();

			let accountList = (res && res.accounts ? res.accounts : []).map((account) => {
				return { [account.uuid]: account.display_name };
			});

			accountList.sort((a, b) => {
				let aName = Object.values(a)[0];
				let bName = Object.values(b)[0];

				if (aName > bName) {
					return 1;
				}

				if (aName < bName) {
					return -1;
				}

				return 0;
			});

			this.setState({
				accountList,
			}, () => {
				const {
					params,
				} = this.props.router;

				if (params.account) {
					this.setAccountUUID(params.account);
				}
			});
		} catch (err) {
			if (err.message.includes('401 Unauthorized')) {
				this.logout();
				return this.redirect({
					to: '/login',
				});
			}

			console.error(err);
		} finally {
			this.setState({
				loading: false,
			}, () => {
				if (typeof cb === 'function') {
					return cb();
				}
			});
		}
	}

	fetchAccounts() {
		// On the accounts landing no account is selected yet — clear any prior lock so
		// the account list isn't scoped to a stale selection.
		setCurrentAccountUUID('');
		this.load(async () => {
			let accountsRes = await fetchAccount();
			if (this.handleOutdatedCommithashValidation(accountsRes)) {
				return;
			}
			let accountList = [];
			for (let [m1Key, m1Data,] of Object.entries(accountsRes.userFD.data)) {
				if (m1Key.startsWith('account.')) {
					let m1UUID = m1Key.split('.')[1];
					let m1Name = m1Data['display_name'];

					accountList.push({
						[m1UUID]: m1Name,
					});
				}
			}

			accountList.sort((a, b) => {
				let aName = Object.values(a)[0];
				let bName = Object.values(b)[0];

				if (aName > bName) {
					return 1;
				}

				if (aName < bName) {
					return -1;
				}

				return 0;
			});

			this.setState({
				accountList,
			}, () => {
				const {
					params,
				} = this.props.router;

				if (accountList.length === 1) {
					let accountUUID = Object.keys(accountList[0]);
					this.redirect({
						to: `/systems/${accountUUID}`,
					});
				}

				if (params.account) {
					this.setAccountUUID(params.account);
				}
			});
		});
	}

	fetchAccount(accountUUID, systemGroupUUID) {
		const {
			accountList,
		} = this.state;

		// Before the await below, not after it: this is the earliest point at which the
		// selection is known to have changed.
		this.clearBuildingsIfSelectionChanged();

		// Listing configs are fetched reactively by ListingConfigProvider off
		// the accountUUID prop (see its useEffect) — no imperative poke needed
		// here, and poking the ref before the provider mounts would race.
		// EXCEPTION: flows that mint new configs under the SAME account (the
		// migration screen) must poke fetchListingConfigs themselves —
		// accountUUID doesn't change, so the provider won't. (DEV-12016)

		this.load(async () => {
			let accountRes = await fetchAccount(accountUUID, systemGroupUUID);

			let accountUUIDs = [];
			for (let accountListObj of accountList) {
				accountUUIDs.push(Object.keys(accountListObj)[0]);
			}

			let accountName = this.state.accountName;
			if (!accountName) {
				accountName = accountRes.data[`account.${accountUUID}`].display_name;
			}

			if (!~accountUUIDs.indexOf(accountUUID)) {
				accountList.push({
					[accountUUID]: accountName,
				});
			}

			this.setState({
				accountName,
				accountList,
				accountFD: accountRes.data,
				settingMap: accountRes.settings,
			}, () => {

				let params = this.params();
				// The Slide Deck / VCL pages render nothing unless the account has the VCL
				// feature enabled (sidebar hides them too). Landing on one anyway — account
				// switch from a VCL-enabled account, or a deep link/refresh — left a blank
				// page under the header. Fall back to the systems hierarchy instead.
				const vclDisabledHere = VCL_MODES.includes(params.mode) &&
					!accountRes.data[`account.${accountUUID}`]?.is_visual_content_loop_enabled;
				if (params.mode === 'accounts' || vclDisabledHere) {
					this.redirect({
						to: `/systems/${accountUUID}`,
					});
				} else {
					this.redirect({
						to: `/${params.mode}/${accountUUID}`,
					});
				}

				this.fetchAccountBuildings();
			});
		});
	}

	fetchAccountTemplates(accountUUID) {
		this.load(async () => {
			let accountRes = await fetchAccountTemplates(accountUUID);
			if (this.handleOutdatedCommithashValidation(accountRes)) {
				return;
			}

			this.setState({
				accountTemplates: accountRes.data,
			});
		});
	}

	fetchAccountSystems(accountUUID) {
		this.load(async () => {
			let accountRes = await fetchAccountSystems(accountUUID);
			if (this.handleOutdatedCommithashValidation(accountRes)) {
				return;
			}

			this.setState({
				accountSystem: {},
				accountSystems: accountRes.data,
			});
		});
	}

	fetchAccountSystem(accountUUID, systemUUID) {
		this.load(async () => {
			let accountRes = await fetchAccountSystem(accountUUID, systemUUID);
			if (this.handleOutdatedCommithashValidation(accountRes)) {
				return;
			}

			this.setState({
				accountSystem: accountRes.data,
			});
		});
	}

	// A different account or system group is a different list, so the rows on screen are
	// wrong the moment the selection changes. Clearing on the change rather than on
	// arrival stops the previous selection's buildings being shown under the new one.
	//
	// Called from fetchAccount as well as from the buildings fetch: both switch paths
	// setState and then await fetchAccount before they ever reach fetchAccountBuildings,
	// so clearing only there left the old rows on screen for the length of that request
	// — and for good if it failed, since the buildings fetch is never reached.
	//
	// Reads the selection from state rather than taking arguments: both callers run
	// inside the setState callback that applied the change, and fetchAccount is passed
	// no systemGroupUUID on an account switch.
	clearBuildingsIfSelectionChanged() {
		const {
			accountUUID,
			systemGroupUUID,
		} = this.state;

		const selection = `${accountUUID}|${systemGroupUUID}`;
		if (this.buildingsSelection === selection) {
			return;
		}

		this.buildingsSelection = selection;

		this.setState({
			buildingsDataArray: [],
		});
	}

	fetchAccountBuildings() {
		const {
			accountUUID,
			systemGroupUUID,
		} = this.state;

		// Every row write re-fetches, so several requests for the SAME selection can be
		// in flight at once and finish out of order — an older pre-write response would
		// otherwise land last and undo what the user just did. Only the newest request
		// may apply its result.
		this.buildingsFetchID = (this.buildingsFetchID || 0) + 1;
		const fetchID = this.buildingsFetchID;

		this.clearBuildingsIfSelectionChanged();

		fetchBuildings(accountUUID, systemGroupUUID)
			.then((buildingsData) => {
				// Superseded by a later fetch, whatever it was for.
				if (this.buildingsFetchID !== fetchID) {
					return;
				}

				// The user may have switched accounts or system groups while this was in
				// flight. The fetch is filtered by both, so applying a stale response now
				// would show one account's — or one group's — buildings under another.
				// Kept alongside the id check: state can change without a new fetch.
				if (this.state.accountUUID !== accountUUID || this.state.systemGroupUUID !== systemGroupUUID) {
					return;
				}

				// fetchBuildings resolves { error, message } on failure; never render
				// that as building rows. Clear rather than return: the rows on screen
				// may belong to the account we just switched away from.
				if (!buildingsData || buildingsData.error) {
					this.setState({
						buildingsDataArray: [],
					});

					return;
				}

				const buildingsDataArray = [];

				Object.entries(buildingsData)
					.forEach(([m1Key, m1Val,]) => {
						const buildingData = {
							m1Key,
							isChecked: false,
							vals: {
								buildingName: m1Val.building_name,
								displayName: m1Val.display_name,
							},
							system_group: m1Val.system_group_uuid,
						};

						buildingsDataArray.push(buildingData);
					});

				this.setState({
					buildingsDataArray,
				});
			});
	}

	setAccountUUID(accountUUID) {
		const {
			accountList,
		} = this.state;

		// Lock subsequent bronco requests to the selected account (X-Account-UUID).
		setCurrentAccountUUID(accountUUID);

		if (this.state.accountUUID === accountUUID && !this.state.systemGroupUUID) {
			console.log('NO_SWITCH_REQUIRED');
			return;
		}

		let accountObjs = accountList.filter((accountObj) => {
			let m1UUID = Object.keys(accountObj)[0];
			if (m1UUID === accountUUID) {
				return true;
			}
		});

		let accountName;
		if (accountObjs.length === 1) {
			accountName = accountObjs[0][accountUUID];
		}

		// Re-resolve permissions for the newly selected account BEFORE committing it to
		// state: under per-account grants the user's role can differ per account (e.g.
		// external_admin on one, property_manager on another). The account cookie is
		// already set above, so this request carries X-Account-UUID and gets the
		// account-specific role.
		//
		// Order matters. Flipping accountUUID first made every mounted page (e.g.
		// SlideDeck) immediately re-fetch for the new account under the OLD role's
		// gates — firing requests the new role can't make (403s) that were then aborted
		// when the permission response redirected the user off the page. Resolving
		// permissions first means a gated page redirects before any page-level loader
		// sees the new account.
		this.apiFetchPermissions(() => {
			// If the user switched accounts while on a permission-gated page (e.g.
			// Roles) and lacks that permission in the new account, don't strand them
			// on a page they can't use — send them to the systems hierarchy. Pages
			// that stay accessible keep their mode and re-fetch their own data.
			const mode = this.props.router.params.mode;
			if (mode && !canAccessMode(mode)) {
				this.redirect({
					to: `/systems/${accountUUID}`,
				});
			}

			this.setState({
				accountUUID,
				accountName,
				systemGroupUUID: '',
			}, () => {
				this.fetchAccount(accountUUID);
			});
		});
	}

	setSystemGroupUUID(systemGroupUUID) {
		const {
			accountUUID,
		} = this.state;

		this.setState({
			systemGroupUUID,
		}, () => {
			this.fetchAccount(accountUUID, systemGroupUUID);
		});
	}

	fetchComponent(componentUUID, isEntertainment = false) {
		this.load(async () => {
			const componentRes = await fetchComponent(componentUUID);

			let settingUUIDMap = {};
			for (let [settingName, settingInfo,] of Object.entries(componentRes.settingMap)) {
				settingUUIDMap[settingInfo.uuid] = settingName;
			}

			this.setState({
				componentUUID,
				componentMap: componentRes.componentMap,
				componentTypeMap: componentRes.componentTypeMap,
				componentSettingMap: componentRes.settingMap,
				settingUUIDMap,
				listingConfigUUID: '',
				slideshow: {},
				entertainment: isEntertainment,
			});
		});
	}

	fetchSlideshow(slideshow = {}) {
		this.setState({
			componentUUID: '',
			componentMap: {},
			componentTypeMap: {},
			componentSettingMap: {},
			settingUUIDMap: {},
			listingConfigUUID: '',
			slideshow,
			entertainment: false,
		});
	}

	fetchEntertainment(componentUUID) {
		this.load(async () => {
			const componentRes = await fetchComponent(componentUUID);

			let settingUUIDMap = {};
			for (let [settingName, settingInfo,] of Object.entries(componentRes.settingMap)) {
				settingUUIDMap[settingInfo.uuid] = settingName;
			}

			this.setState({
				componentUUID,
				componentMap: componentRes.componentMap,
				componentTypeMap: componentRes.componentTypeMap,
				componentSettingMap: componentRes.settingMap,
				settingUUIDMap,
				listingConfigUUID: '',
				slideshow: false,
				entertainment: true,
			});
		});
	}

	openModal(modalProps) {
		modalProps.app = this;

		if (modalProps.library) {
			this.setState({
				libraryModal: true,
				libraryModalProps: modalProps,
			});

			return;
		}

		this.setState({
			modal: true,
			modalProps,
		});
	}

	closeModal(cb = () => { }) {
		this.setState({
			modal:                       false,
			modalProps:                  {},
			pendingChanges:              {},
			accountFDWithPendingChanges: this.state.accountFD,
		}, () => {
			cb();
		});
	}

	closeModalAndKeepPendingChanges(cb = () => { }) {
		this.setState({
			modal: false,
		}, () => {
			cb();
		});
	}

	closeLibraryModal(cb = () => { }) {
		this.setState({
			libraryModal: false,
			libraryModalProps: {},
		}, () => {
			cb();
		});
	}

	startBackgroundDownload(label) {
		this.backgroundDownloadSeq = (this.backgroundDownloadSeq || 0) + 1;
		const id = `download_${this.backgroundDownloadSeq}`;

		this.setState((prevState) => {
			return {
				backgroundDownloads: addDownload(prevState.backgroundDownloads, id, label),
			};
		});

		return id;
	}

	updateBackgroundDownload(id, patch) {
		this.setState((prevState) => {
			return {
				backgroundDownloads: updateDownload(prevState.backgroundDownloads, id, patch),
			};
		});
	}

	endBackgroundDownload(id) {
		this.setState((prevState) => {
			return {
				backgroundDownloads: removeDownload(prevState.backgroundDownloads, id),
			};
		});
	}

	openPendingChangesModal(name, noSaveCB = () => { }, saveCB = () => { }) {
		const modalProps = {
			modalSize: 1,
			showModal: true,
			modalProps: {
				title: 'You Have Unsaved Changes',
				omitClose: true,
				jsx: (
					<PendingChangesModalView
						app={this}
						name={name}
						noSaveCB={noSaveCB}
						saveCB={saveCB}
					/>
				),
			},
		};

		this.setState({
			modal: true,
			modalProps,
		});
	}

	clearPendingChanges() {
		this.setState({
			pendingChanges:              {},
			pendingSlideshowChanges:     {},
			pendingPromises:             {},
			pendingPromiseGroups:        {},
			accountFDWithPendingChanges: this.state.accountFD,
		});
	}

	clearPendingChangesAndCloseModal(name, noSaveCB = () => { }) {
		this.setState({
			pendingChanges:              {},
			pendingSlideshowChanges:     {},
			pendingPromises:             {},
			pendingPromiseGroups:        {},
			modal:                       false,
			modalProps:                  {},
			accountFDWithPendingChanges: this.state.accountFD,
		}, () => {
			noSaveCB();
		});
	}

	setValue(name, entityNames, values, cb = () => { }) {
		if (!Array.isArray(entityNames)) {
			entityNames = [entityNames,];
		}
		if (!Array.isArray(values)) {
			values = [values,];
		}

		if (entityNames.length !== values.length) {
			if (entityNames.length !== 1 || !entityNames[0].endsWith('._bundle')) {
				throw Error('keys.length !== vals.length');
			}
		}

		this.setState((prevState) => {
			const { accountFD } = prevState;
			let newPendingChanges = { ...prevState.pendingChanges };

			for (const key in newPendingChanges) {
				if (typeof newPendingChanges[key] === 'string') {
					newPendingChanges[key] = newPendingChanges[key].trim();
				}
			}

			entityNames.forEach((entityName, i) => {
				let value = values[i];
				if (entityName.endsWith('._bundle')) {
					value = values;
				}

				// newPendingChanges[name][entityName] = value;
				newPendingChanges[entityName] = value;

				// TODO: check if value = accountFD so as not
				// TODO: to store pendingChanges that aren't real
				let info = parseEntityName(entityName);

				if (info.type === 'rel') {
					let m1Key = `${info.m1}.${info.m1ID}`;
					let m2Key = `${info.m2}.${info.m2ID}`;

					let orgValue = (accountFD[m1Key] || {})[m2Key];
					if (orgValue && value === true) {
						Reflect.deleteProperty(newPendingChanges, entityName);
					}
					if (!orgValue && value === false) {
						// Reflect.deleteProperty(newPendingChanges, entityName);
					}
				}
			});

			// console.log('CHANGES:', newPendingChanges);
			return {
				pendingChanges:                newPendingChanges,
				accountFDWithPendingChanges:   mergeFD(accountFD, makeFDFromDD(newPendingChanges)),
			};
		}, () => {
			if (typeof cb === 'function') {
				return cb();
			}
		});
	}

	delValue(name, entityNames, cb = () => { }) {
		const {
			accountFD,
			pendingChanges,
		} = this.state;

		if (!Array.isArray(entityNames)) {
			entityNames = [entityNames,];
		}

		let newPendingChanges = { ...pendingChanges };
		entityNames.forEach((entityName, i) => {
			let l = entityName.split('.').length;
			let [m1, m1ID, m2, m2ID,] = entityName.split('.');

			let m1Key = `${m1}.${m1ID}`;
			let m2Key = `${m2}.${m2ID}`;

			if (l === 2 || l === 4) {
				// remove m1.m1ID.*?.*?.*
				Object.keys(newPendingChanges).filter((key) => {
					if (key.startsWith(entityName)) {
						return true;
					}
				}).forEach((key) => {
					Reflect.deleteProperty(newPendingChanges, key);
				});

				if (l === 2) {
					if (accountFD[m1Key]) {
						// newPendingChanges[entityName] = false;
					}
				}

				if (l === 4) {
					if (accountFD[m1Key] && accountFD[m1Key][m2Key]) {
						newPendingChanges[entityName] = false;
					}
				}
			}
		});

		this.setState({
			pendingChanges:                newPendingChanges,
			accountFDWithPendingChanges:   mergeFD(accountFD, makeFDFromDD(newPendingChanges)),
		}, () => {
			if (typeof cb === 'function') {
				return cb();
			}
		});
	}

	delPendingChange(entityNames = [], cb = () => { }) {
		if (!Array.isArray(entityNames)) {
			entityNames = [entityNames,];
		}

		let pendingChanges = Object.assign({}, this.state.pendingChanges);
		for (let entityName of entityNames) {
			Reflect.deleteProperty(pendingChanges, entityName);
		}

		this.setState({
			pendingChanges,
			accountFDWithPendingChanges: mergeFD(this.state.accountFD, makeFDFromDD(pendingChanges)),
		}, () => {
			if (typeof cb === 'function') {
				return cb();
			}
		});
	}

	setBulkProcessing(isBulkProcessing) {
		this.setState({ isBulkProcessing });
	}

	hasPendingChanges(name) {
		if (this.state.isBulkProcessing) return false;
		const {
			pendingChanges,
		} = this.state;
		return (Object.keys(pendingChanges).length > 0);
	}

	hasPendingSlideshowChanges() {
		if (this.state.isBulkProcessing) return false;
		const {
			pendingSlideshowChanges,
		} = this.state;
		return (Object.keys(pendingSlideshowChanges).length > 0);
	}

	hasPendingPromises() {
		const {
			pendingPromises,
			pendingPromiseGroups,
		} = this.state;

		if (Object.keys(pendingPromises || {}).length > 0) {
			return true;
		}
		for (const group of Object.values(pendingPromiseGroups || {})) {
			if (Object.keys(group.thunks || {}).length > 0) {
				return true;
			}
		}
		return false;
	}

	injectContentPendingChanges(componentMap) {
		let {
			pendingChanges,
			componentSettingMap,
			settingUUIDMap,
		} = this.state;

		pendingChanges = makeFDFromDD(pendingChanges);
		if (Object.keys(pendingChanges).length === 0) {
			return componentMap;
		}

		let newComponentMap = JSON.parse(JSON.stringify(componentMap));
		for (let [m1Key, m1Data,] of Object.entries(pendingChanges)) {
			if (m1Key.startsWith('component.')) {
				for (let [m2Key, m2Data,] of Object.entries(m1Data)) {
					if (m2Key.startsWith('setting.')) {
						let componentUUID = m1Key.split('.')[1];
						if (!componentMap[componentUUID]) {
							continue;
						}

						let settingUUID = m2Key.split('.')[1];
						let settingName = settingUUIDMap[settingUUID];
						let setting = componentSettingMap[settingName];

						let value = m2Data[setting.type];
						newComponentMap[componentUUID].settings[settingName] = value;
					}
				}
			}
		}

		return newComponentMap;
	}

	setNetworkErrorModal(retry = true, message = '') {
		this.setState({
			confirmModal: true,
			confirmModalContent: <>
				<p>{message || 'A network error has occured.'}</p>
				<div className="confirm-modal-buttons">
					{retry && <button className="button-outlined" onClick={(e) => {
						this.setState({
							confirmModal: false,
						});
						this.saveData();
					}}>Retry</button>}
					<button className="button" onClick={(e) => {
						this.setState({
							confirmModal: false,
						});
					}}>Return</button>
				</div>
			</>,
		});
	}

	setCommitHashErrorModal() {
		this.setState({
			confirmModal: true,
			confirmModalContent: <>
				<p>You have an outdated version of the Spark Dashboard.</p>
				<p>Please, clear locally stored data from Spark from your browser and retry.</p>
				<div className="confirm-modal-buttons">
					<button className="button-outlined" onClick={() => {
						this.setState({
							confirmModal: false,
						});

						this.logout();

					}}>Logout</button>
					<button className="button" onClick={() => {
						this.setState({
							confirmModal: false,
						});
					}}>Cancel</button>
				</div>
			</>,
		});
	}

	renderEntity(entity, props = {
		fd: {},
	}) {
		let mode = this.params().mode;
		let fieldProps = {
			...props,
			...entity,
			app: this,
			key: entity.name,
			entity,
			value: getFDValue(props.fd, entity.name),
			placeholder: entity.placeholder || null,
			setValue: this.setValue.bind(this, mode, entity.name),
			bucketName: this.state.bucketName,
		};
		if (Object.keys(props.fd).length > 0 && !fieldProps.value) {
			// debugger;
		}

		let Field;
		switch (entity.fieldType) {
		// case 'custom.vulture.infobox':
		// 	Field = CrowFieldCustomVultureInfobox;
		// 	break;
		// case 'custom.vulture.elements.OnOff':
		// 	Field = CrowFieldCustomVultureElementsOnOff;
		// 	break;
		case 'custom.vulture.elements.float':
			Field = CrowFieldCustomVultureElementsFloat;
			break;
		case 'custom.vulture.elements.text.small':
			Field = CrowFieldCustomVultureElementsTextSmall;
			break;
		case 'custom.vulture.elements.text.large':
			Field = CrowFieldCustomVultureElementsTextLarge;
			break;
		case 'custom.vulture.elements.phone.number':
			Field = CrowFieldCustomVultureElementsPhoneNumber;
			break;
		case 'custom.vulture.elements.number':
			Field = CrowFieldCustomVultureElementsNumber;
			break;
		case 'custom.vulture.elements.icon':
			Field = CrowFieldCustomVultureElementsIcon;
			break;
		case 'custom.vulture.elements.email':
			Field = CrowFieldCustomVultureElementsEmail;
			break;
		case 'custom.vulture.elements.slack':
			Field = CrowFieldCustomVultureElementsSlack;
			break;
		case 'custom.vulture.elements.uploader':
			fieldProps.component = {
				settings: {
					source:     fieldProps.value || '',
					isListings: true,
				},
			};
			fieldProps.accountUUID = this.state.accountUUID;
			Field = ImageUploaderComponent;
			break;
			// case 'custom.vulture.elements.json':
			// 	Field = CrowFieldCustomVultureElementsJSON;
			// 	break;
		case 'custom.vulture.qrcode':
			fieldProps.component = {

				settings: {
					url:             fieldProps.value || '',
					parentDirectory: fieldProps.attr.parent_directory || '',
					isListings:      true,
				},
			};
			Field = QrCodeComponent;
			break;
		case 'custom.vulture.elements.drop.down':
			Field = CrowFieldCustomVultureDropDown;
			break;
		case 'custom.vulture.elements.phone.message':
			Field = CrowFieldCustomVultureElementsPhoneMessage;
			break;
		case 'custom.vulture.elements.resolution.drop.down':
			Field = CrowFieldCustomVultureResolutionDropDown;
			break;
		case 'custom.vulture.elements.advanced.checkbox':
			Field = CrowFieldCustomVultureAdvancedCheckbox;
			break;
		case 'custom.common.date':
			Field = CrowFieldCustomCommonDate.field;
			break;
		case 'custom.common.date.timezone':
			Field = CrowFieldCustomCommonDateTimezone.field;
			break;
		case 'custom.common.date.time':
			Field = CrowFieldCustomCommonDateTime.field;
			break;
		// case 'custom.common.maintenance.mode':
		// 	Field =
		default:
			Field = function (props) {
				return (
					<div
						key={fieldProps.key}
					>invalid_field: {entity.fieldType}</div>
				);
			};
		}

		if (Field.name === 'custom.common.date.timezone') {
			// debugger;
		}

		return (
			<Field {...fieldProps} />
		);
	}

	getHashedActiveAccountName() {
		return md5(this.state.accountUUID);
	}

	uploadPhotosToBucket(file, objKey, bucketName = this.state.bucketName) {
		s3.upload(
			{
				Body:   file,
				Bucket: bucketName,
				Key:    objKey,
				ACL:    'public-read',
			},
			(err, data) => {
				if (err) {
					console.error(err, data);
					alert(`There was an error uploading your file: `, err.message);
					return;
				}
				return;
			}
		);
	}

	async registerListingIntegration({
		accountUUID,
		listingConfigUUID,
		provider,
		integrationList,
		email,
		authCode,
		key,
		mallID,
		mapID,
	}) {
		const {
			accountFD,
		} = this.state;

		const listingConfigFD = await registerListingIntegration({
			accountUUID,
			listingConfigUUID,
			provider,
			integrationList,
			email,
			authCode,
			key,
			mallID,
			mapID,
		});

		Object.entries(listingConfigFD).forEach(([m1Key, m1Val,]) => {
			accountFD[m1Key] = m1Val;
		});

		this.setState({
			accountFD,
		});

		return listingConfigFD;
	}

	async updateViewData(data, slideshowUITableConfigUUID) {
		let viewFD;

		try {
			viewFD = await updateViewData(data, slideshowUITableConfigUUID);
		} catch (err) {
			console.error(err);
			alert(`Error Saving: ${err}`);
			return false;
		}

		if (!viewFD) {
			const err = 'No data returned from updateViewData';
			console.error(err);
			alert(`Error Saving: ${err}`);
			return false;
		}

		return new Promise((resolve) => {
			this.setState((state) => {
				const {
					slideshow,
				} = state;

				return {
					slideshow: {
						...slideshow,
						ui_table_config: data,
					},
				};
			}, () => {
				resolve(true);
			});
		});
	}

	async applySystemTemplateAssignment(accountUUID, assignmentMap) {
		const updatedFD = await applySystemTemplateAssignment(accountUUID, assignmentMap);

		if (!updatedFD) {
			return;
		}

		const {
			accountFD,
			accountSystems,
		} = this.state;

		this.setState({
			accountFD: {
				...accountFD,
				...updatedFD,
			},
			accountSystems: {
				...accountSystems,
				...updatedFD,
			},
		});
	}

	render() {
		const {
			accountFD,
			accountList,
			accountName,
			accountSystem,
			accountSystems,
			accountTemplates,
			accountUUID,
			listingConfigUUID,
			entertainment,
			slideshow,
			componentUUID,
			componentMap,
			componentTypeMap,
			componentSettingMap,
			settingUUIDMap,
			settingMap,
			pendingChanges,
			pendingSlideshowChanges,
			loading,
			pendingRequests,
			backgroundDownloads,
			forceLoading,
			modal,
			modalProps,
			libraryModal,
			libraryModalProps,
			photos,
			stockPhotos,
			bucketName,
			systemGroupUUID,
			buildingsDataArray,
			accountFDWithPendingChanges,
			permissions,
			sideBarClickTime,
		} = this.state;

		// TODO: mode instead of window.location.pathname
		if (!hasSession() && window.location.pathname === '/') {
			return (
				<SplitScreenView
					app={this}
				/>
			);
		}

		let loginPathnames = [
			'/password/reset',
			'/password',
			'/register',
			'/login',
			'/mfa',
		];

		let isLoginPathname = false;
		loginPathnames.forEach((pn) => {
			if (isLoginPathname) {
				return;
			}

			isLoginPathname = window.location.pathname.startsWith(pn);
		});

		if (!hasSession() && !isLoginPathname) {
			// if session expires w/ modal open
			// then it can return w/ modal open
			this.closeModal();

			// this.redirect({
			// 	to: '/login',
			// });

			this.logout();

			return '';
		}

		if (!hasSession() || isLoginPathname) {
			if (window.location.pathname.startsWith('/password/reset')) {
				return (
					<LoginView
						app={this}
						mode={'resetPassword'}
					/>
				);
			}
			if (window.location.pathname.startsWith('/register')) {
				return (
					<LoginView
						app={this}
						mode={'register'}
					/>
				);
			}
			if (window.location.pathname.startsWith('/mfa')) {
				return (
					<>
						{(loading || forceLoading || pendingRequests > 0) &&
							<LoadingView
								app={this}
							/>
						}
						<MFAView
							app={this}
						/>
					</>
				);
			}

			return (
				<LoginView
					app={this}
				/>
			);
		}

		// Wait for permissions to be initialized before rendering the main app
		if (!this.state.permissionsInitialized) {
			return (
				<LoadingView
					app={this}
				/>
			);
		}

		let params = this.params();

		let fdLoading = false;
		if (accountUUID && Object.keys(accountFDWithPendingChanges).length === 0) {
			fdLoading = true;
		}

		let isVCLEnabled = false;
		if (accountUUID && !fdLoading) {
			isVCLEnabled = accountFD[`account.${accountUUID}`]?.is_visual_content_loop_enabled || false;
		}

		let isInFolderSchedulingEnabled = false;
		if (accountUUID && !fdLoading) {
			isInFolderSchedulingEnabled = !!(accountFD[`account.${accountUUID}`]?.is_in_folder_scheduling_enabled);
		}

		if (
			params.mode === 'data_presets' ||
			params.mode === 'entertainment' ||
			params.mode === 'library' ||
			params.mode === 'migration' ||
			params.mode === 'screenshots' ||
			params.mode === 'slide_deck' ||
			params.mode === 'system_assignment' ||
			params.mode === 'system_programming' ||
			params.mode === 'users' ||
			params.mode === 'accountUsers' ||
			params.mode === 'userAdmin' ||
			params.mode === 'visual_content_loop'
		) {
			fdLoading = false;
		}

		let confirmModal = '';
		if (this.state.confirmModal === true) {
			confirmModal = (
				<div className="confirm-modal-container">
					<div className="confirm-modal-content">
						{this.state.confirmModalContent}
					</div>
				</div>
			);
		}

		return (
			<DndProvider backend={HTML5Backend}>
				<VisualContentLoopProvider isInFolderSchedulingEnabled={isInFolderSchedulingEnabled}>
					<ListingConfigProvider
						ref={this.listingConfigRef}
						app={this}
						accountUUID={this.state.accountUUID}
						mode={params.mode}
					>
						{confirmModal}
						{(loading || fdLoading || forceLoading || pendingRequests > 0) &&
							<LoadingView
								app={this}
							/>
						}

					<BackgroundDownloadsView
						downloads={backgroundDownloads}
					/>

						{modal &&
							<ModalView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								settingMap={settingMap}
								pendingChanges={pendingChanges}
								{...modalProps}
							/>
						}

						{libraryModal &&
							<ModalView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								settingMap={settingMap}
								pendingChanges={pendingChanges}
								photos={photos}
								stockPhotos={stockPhotos}
								{...libraryModalProps}
							/>
						}

						<HeaderView
							app={this}
							mode={params.mode}
							accountUUID={accountUUID}
							accountName={accountName}
							accountList={accountList || []}
							settingMap={settingMap}
							systemGroupUUID={systemGroupUUID}
							fd={accountFDWithPendingChanges}
						/>

						{sparkieEnabled() &&
						<Sparkie
							open={this.state.sparkieOpen}
							onClose={() => this.closeSparkie()}
							metadata={{
								mode: params.mode,
								accountUUID,
								accountName,
							}}
						/>
					}

						<SidebarView
							app={this}
							accountUUID={accountUUID}
							accountName={accountName}
							isVCLEnabled={isVCLEnabled}
							pendingChanges={pendingChanges}
						/>

						{(params.mode === 'accounts' && Array.isArray(accountList)) &&
							<AccountsView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								accountList={accountList}
							/>
						}

						{(params.mode === 'billing') &&
							<BillingView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								permissions={permissions}
							/>
						}

						{(params.mode === 'calendar' || params.mode === 'connect') &&
							<div
								style={{
									marginTop:  '75px',
									marginLeft: '75px',
								}}
							>
								<input value="email" name="email-input" />
								<button
									onClick={(e) => {
										let email = document.getElementsByName('email-input')[0].value;
										axios.post(`http://localhost:9999/calendar/auth/google?email=${email}`)
											.then((res) => {
												console.log(res);
												debugger;
											})
											.catch((err) => {
												console.error(err);
												debugger;
											});
									}}
								>
									login
								</button>
								{/* {params.mode === 'calendar' && */}
								<div>
									<p>auth_state: {new URL(location.href).searchParams.get('state')}</p>
									<p> auth_code: {new URL(location.href).searchParams.get('code')}</p>
									<p>auth_scope: {new URL(location.href).searchParams.get('scope')}</p>
								</div>
								{/* } */}
							</div>
						}

						{params.mode === 'support' &&
							<SupportView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
							/>
						}

						{params.mode === 'proof_of_play' &&
							<ProofOfPlayView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
							/>
						}

						{(accountUUID && Object.keys(accountFD).length > 0 && params.mode === 'systems') &&
							<SystemsView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								settingMap={settingMap}
								systemGroupUUID={systemGroupUUID}
								setSystemGroupUUID={this.setSystemGroupUUID}
								roleUUID={permissions && permissions.role_uuid}
							/>
						}

						{(accountUUID && params.mode === 'library') &&
							<LibraryView
								app={this}
								accountUUID={accountUUID}
								isVCLEnabled={isVCLEnabled}
								fd={accountFDWithPendingChanges}
								photos={photos}
								stockPhotos={stockPhotos}
								permissions={permissions}
							/>
						}

						{(accountUUID && isVCLEnabled && params.mode === 'slide_deck') &&
							<SlideDeckView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								sideBarClickTime={sideBarClickTime}
							/>
						}

						{(accountUUID && isVCLEnabled && params.mode === 'visual_content_loop') &&
							<VisualContentLoopsView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
							/>
						}

						{(accountUUID && params.mode === 'ai_generation_dashboard') &&
							<AIGenerationDashboardView
								app={this}
								accountUUID={accountUUID}
								systemGroupUUID={systemGroupUUID}
							/>
						}


						{(accountUUID && params.mode === 'content') &&
							<ContentView
								app={this}
								accountUUID={accountUUID}
								systemGroupUUID={systemGroupUUID}
								buildingsDataArray={buildingsDataArray}
								fd={accountFDWithPendingChanges}
								settingMap={settingMap}
								componentUUID={componentUUID}
								componentMap={this.injectContentPendingChanges(componentMap)}
								componentTypeMap={componentTypeMap}
								componentSettingMap={componentSettingMap}
								settingUUIDMap={settingUUIDMap}
								listingConfigUUID={listingConfigUUID}
								entertainment={entertainment}
								slideshow={slideshow}
								pendingChanges={pendingChanges}
								pendingSlideshowChanges={pendingSlideshowChanges}
								bucketName={bucketName}
							/>
						}

						{/* settings_access is internal-admin-only; the sidebar hides the
						    link but the URL is still typable — gate the mount too */}
						{/* no accountUUID guard: if the account payload failed to load
						    (permission-limited fetch) the denial must still render
						    instead of a blank page */}
						{(params.mode === 'account_settings' && !hasPermission('settings_access')) &&
							<div style={{ padding: '2rem', }} data-test-id="accountSettingsPermissionDenied">
								You do not have permission to view Account Settings.
							</div>
						}

						{(accountUUID && params.mode === 'account_settings' && hasPermission('settings_access')) &&
							<AccountSettingsView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								pendingChanges={pendingChanges}
								settingMap={settingMap}
							/>
						}

						{(accountUUID && params.mode === 'system_programming') &&
							<SystemProgrammingView
								app={this}
								accountUUID={accountUUID}
								fd={mergeFD(mergeFD(mergeFD(mergeFD(mergeFD({}, accountTemplates), accountFD), accountSystems), accountSystem), makeFDFromDD(pendingChanges))}
								pendingChanges={pendingChanges}
								settingMap={settingMap}
							/>
						}

						{(params.mode === 'screenshots') &&
							<ScreenshotView
								app={this}
								fd={accountFDWithPendingChanges}
							/>
						}

						{(params.mode === 'data_presets') &&
							<DataPresetsView
								app={this}
							/>
						}

						{(params.mode === 'role_management') &&
							<RoleManagementView
								app={this}
								accountUUID={accountUUID}
							/>
						}

						{(params.mode === 'userAdmin') &&
							<UserAdminView
								app={this}
								filterAccountUUID={params.account || ''}
							/>
						}

						{(params.mode === 'user_profile') &&
							<UserProfileView
								app={this}
							/>
						}

						{(accountUUID && params.mode === 'theme_editor') &&
							<CrowFieldCustomVultureThemeEditor
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								mode={params.mode}
								form={window.form}
								settingMap={settingMap}
							/>
						}

						{(params.mode === 'system_assignment') &&
							<SystemAssignmentView
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								mode={params.mode}
							/>
						}

						{(params.mode === 'entertainment') &&
							<EntertainmentEditor
								app={this}
								accountUUID={accountUUID}
								fd={accountFDWithPendingChanges}
								mode={params.mode}
							/>
						}

						{(params.mode === 'folder_navigation') &&
							<ChonkyFileBrowser
								app={this}
							/>
						}

						{(params.mode === 'migration') &&
							<MigrationView
								app={this}
								accountUUID={accountUUID}
							/>
						}
					</ListingConfigProvider>
				</VisualContentLoopProvider>
			</DndProvider>
		);
	}
}

const VultureFormLogin = DashboardView;
export default VultureFormLogin;